<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-body text-center">
                            <ComponentImageLinks 
                            prop_image_alt_text="front view image" 
                            v-bind:prop_image_url_size_medium="data_image_link_frontview.img_links.medium" 
                            v-bind:prop_image_url_size_small="data_image_link_frontview.img_links.small"/>
                        </div>
                        <div class="card-footer bg-light text-center">
                            <p><strong>Front View</strong></p>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-body text-center">
                            <ComponentImageLinks 
                            prop_image_alt_text="surveillance poster image" 
                            v-bind:prop_image_url_size_medium="data_image_link_poster.img_links.medium" 
                            v-bind:prop_image_url_size_small="data_image_link_poster.img_links.small"/>
                        </div>
                        <div class="card-footer bg-light text-center">
                            <p><strong>Surveillance poster</strong></p>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-body text-center">
                            <ComponentImageLinks 
                            prop_image_alt_text="updated case-file image" 
                            v-bind:prop_image_url_size_medium="data_image_link_casefile.img_links.medium" 
                            v-bind:prop_image_url_size_small="data_image_link_casefile.img_links.small"/>
                        </div>
                        <div class="card-footer bg-light text-center">
                            <p><strong>Updated Case-file</strong></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer">
                <button class="btn btn-success btn-block" @click="data_open_dialog = true">
                    show all submission media
                </button>
            </div>
        </div>
        <v-row justify="center" v-if="prop_show_modal_for_all">
            <v-dialog v-model="data_open_dialog" scrollable max-width="600px">
                <v-card>
                    <v-card-title class="headline">
                        <h4>all submission media</h4>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <div v-if="data_qsts!=undefined">
                            <div v-for="(data_qst,index) in data_qsts" v-bind:key="index">
                                <!-- ############################################################## -->
                                <!-- IMAGE -->
                                <!-- ############################################################## -->
                                <div class="row" v-if="data_qst.qst!=undefined">
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="card">
                                            <div class="card-body text-center">
                                                <ComponentImageLinks 
                                                v-bind:prop_image_alt_text="data_qst.qst" 
                                                v-bind:prop_image_url_size_medium="data_qst.img_links.medium" 
                                                v-bind:prop_image_url_size_small="data_qst.img_links.small"/>
                                            </div>
                                            <div class="card-footer bg-light text-center">
                                                <p><strong>{{data_qst.qst}}</strong></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- ############################################################## -->
                            </div>
                        </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn color="danger" text @click="data_open_dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

import {Facades_Apps_Urls} from '@/libs/links/links_to_pages.js';

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS
import ComponentImageLinks from '@/components/ComponentImageLinks';

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentMedia',

    props:[
        'prop_show_modal_for_all',
        'prop_submission'
    ],

    components:{
        //GENERIC COMPONENTS
        ComponentImageLinks,
    },

    data: function()
    {
        return {
            data_open_dialog:false
        }
    },

    computed:{
        data_image_link_frontview:function()
        {
            if(this.prop_submission==undefined || this.prop_submission.length == 0)
            {
                return helper_generate_qst_img_links.call(this,undefined)
            }
            else
            {
                return helper_generate_qst_img_links.call(
                    this,
                    this.prop_submission[0].qsts_all["GrpInformtn/FacilityPic"],
                )
            }
        },
        data_image_link_poster:function()
        {
            if(this.prop_submission==undefined || this.prop_submission.length == 0)
            {
                return helper_generate_qst_img_links.call(this,undefined)
            }
            else
            {
                return helper_generate_qst_img_links.call(
                    this,
                    this.prop_submission[0].qsts_all["AFPsurvel01/AFPsurvel10"],
                )
            }
        },
        data_image_link_casefile:function()
        {
            if(this.prop_submission==undefined || this.prop_submission.length == 0)
            {
                return helper_generate_qst_img_links.call(this,undefined)
            }
            else
            {
                return helper_generate_qst_img_links.call(
                    this,
                    this.prop_submission[0].qsts_all["AFPsurvel01/Specimen006"],
                )
            }
        },
        data_qsts:function()
        {
            if(this.prop_submission==undefined || this.prop_submission.length == 0)
            {
                return undefined
            }
            else
            {
                return [
                    helper_generate_qst_img_links.call(this,this.prop_submission[0].qsts_all["GrpInformtn/FacilityPic"]),
                    helper_generate_qst_img_links.call(this,this.prop_submission[0].qsts_all["AFPsurvel01/AFPsurvel10"]),
                    helper_generate_qst_img_links.call(this,this.prop_submission[0].qsts_all["AFPsurvel01/Specimen006"])
                ]
            }
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

/**
 * check the link-ref is not undefined
 */
function helper_generate_qst_img_links(param_qst_obj)
{
    //OBJ CONTEXT
    var self=this;

    if(param_qst_obj!==undefined)
    {
        let gen_img_links=Facades_Apps_Urls.fmoh_iss_gen_img_link(
            self.$route.params.username,
            self.$route.params.form_id,
            self.$route.params.form_name,
            param_qst_obj.selected_options[0].name
        );
        return{
            img_links:gen_img_links,
            qst:param_qst_obj.question
        };
    }
    else
    {
        let gen_img_links=Facades_Apps_Urls.fmoh_iss_gen_img_link("not_answered");
        return{
            img_links:gen_img_links,
            qst:undefined
        };
    }
}

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
